export type TimesheetApproval = {
  approverId?: number;
  approverName?: string;
  approverType?: string;
  status?: string;
  comment?: string | null;
  actedAt?: string | null;
  projectId?: number | null;
};

/**
 * Resolve the approval row for a project/misc group from the sheet-level approvals array.
 * Match by projectId (null = Miscellaneous). At most one APPROVED/REJECTED per group;
 * otherwise prefer DL (project) or RM (misc) for PENDING/SKIPPED.
 */
export function resolveGroupApproval(
  approvals: TimesheetApproval[] | undefined,
  projectId: number | null,
  isMisc: boolean,
): TimesheetApproval | null {
  if (!approvals?.length) return null;

  const forGroup = approvals.filter(
    (a) => (a.projectId ?? null) === (projectId ?? null),
  );
  if (!forGroup.length) return null;

  const decided = forGroup.find(
    (a) => a.status === "APPROVED" || a.status === "REJECTED",
  );
  if (decided) return decided;

  const preferredType = isMisc ? "RM" : "DL";
  return (
    forGroup.find((a) => a.approverType === preferredType) ?? forGroup[0]
  );
}

export function resolveGroupApprovalStatus(
  approvals: TimesheetApproval[] | undefined,
  projectId: number | null,
  isMisc: boolean,
): string | undefined {
  const row = resolveGroupApproval(approvals, projectId, isMisc);
  return row?.status ?? undefined;
}
